import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PendoUserMetaDirective } from './pendo-user-meta.directive';
import { IPendoConfig, PendoConfig } from './pendo.config';
import { PendoService } from './pendo.service';
import { pendoToken } from './pendo.token';

@NgModule({
  imports: [CommonModule],
  declarations: [PendoUserMetaDirective],
  exports: [PendoUserMetaDirective],
})
export class PendoModule {
  static forRoot(config: IPendoConfig) {
    return {
      ngModule: PendoModule,
      providers: [
        PendoService,
        { provide: pendoToken, useValue: PendoModule.getPendoInstance(config) },
        {
          provide: PendoConfig,
          useValue: config,
        },
      ],
    };
  }

  private static getPendoInstance(config: IPendoConfig): typeof pendo | undefined {
    if (!config.enabled) {
      return undefined;
    }

    const returnValue = (window as any).pendo ?? undefined;

    return returnValue;
  }
}
